import { useNavigate } from 'react-router-dom';

import { useCreateOrganizationDialog } from '@cast/features-organization-shared-create';

export const useOneclickCreateOrganizationDialog = () => {
  const navigate = useNavigate();

  return useCreateOrganizationDialog({
    setOrganizationOptions: { skipRedirect: true },
    onOrganizationCreated: () => {
      // Defer navigation so org id / query cache updates settle first.
      queueMicrotask(() => {
        navigate('/onboarding', { replace: true });
      });
    },
  });
};
